import React, { PureComponent } from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
} from '@lifeomic/chroma-react/styles';
import { IntlShape, injectIntl } from 'react-intl';
import withIsMobile, {
  WithIsMobileInjectedProps,
} from '../../../../hoc/withIsMobile';
import SurveyItem from '../../util/SurveyItem';
import { Text } from '@lifeomic/chroma-react/components/Text';
import SurveyProgress from '../SurveyProgress';
import { withSurveyContext, WithSurveyContextInjectedProps } from '../Contexts';

const styles = () =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
      alignItems: 'flex-start',
    },
    titleContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    progressText: {
      minWidth: 70,
      textAlign: 'right',
    },
  });

export interface SurveyPageHeaderOwnProps {
  surveyItem: SurveyItem;
}

export type SurveyPageHeaderProps = SurveyPageHeaderOwnProps &
  WithStyles<typeof styles> &
  IntlShape &
  WithIsMobileInjectedProps &
  WithSurveyContextInjectedProps;

class SurveyPageHeader extends PureComponent<SurveyPageHeaderProps> {
  getHeadingText = () => {
    const {
      surveyItem: { hasPrefix, prefix, hasText, text },
    } = this.props;

    if (hasPrefix) {
      return {
        heading: prefix,
        subHeading: hasText ? text : null,
      };
    } else {
      return {
        heading: hasText ? text : null,
        subHeading: null,
      };
    }
  };

  renderProgress = () => {
    if (!this.props.isMobile) return null;

    return (
      <SurveyProgress
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        survey={this.props.survey}
        currentPageLink={this.props.surveyItem.link}
        variant="text"
        className={this.props.classes.progressText}
      />
    );
  };

  render() {
    const { classes } = this.props;

    const headingText = this.getHeadingText();

    return (
      <div className={classes.root}>
        <div className={classes.titleContainer}>
          {headingText.heading === null ? null : (
            <Text size="headline">{headingText.heading}</Text>
          )}
          {headingText.subHeading === null ? null : (
            <Text size="subbody">{headingText.subHeading}</Text>
          )}
        </div>
        {this.renderProgress()}
      </div>
    );
  }
}

export default withStyles(styles)(
  injectIntl(withSurveyContext(withIsMobile(SurveyPageHeader))),
);
